import React, { useState } from 'react'
import { IoClose } from "react-icons/io5";




interface IProps {
    image: string
}


const Image: React.FC<IProps> = ({image}) => {
    const [imageModal, setImageModal] = useState<boolean>(false);

  return (
    <>
         <div>
            {/* Image Thumbnail */}
            <div className='  min-w-20 w-[250px] h-[250px] p-4 bg-gray-100 rounded-lg'>
                <img 
                    onClick={() => setImageModal(true)} 
                    className='cursor-pointer h-full w-full  rounded-lg ' 
                    src={image} 
                    alt="defaultImage" 
                />
            </div>

            {/* Modal */}
            {imageModal && (
                <div 
                    onClick={() => setImageModal(false)} 
                    className=' fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-75 transition-opacity duration-300 ease-out'
                > 
                    <div 
                        className='w-full h-full absolute'
                        onClick={() => setImageModal(false)}
                    ></div>

                    <div 
                        className=' w-2/3 md:w-1/3 h-1/3 md:h-1/2 relative rounded-lg z-10' 
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Image */}
                        <img 
                            src={image} 
                            alt={'name' + image} 
                            className=' w-full h-full rounded-lg '
                        />
                        
                        {/* Close Button */}
                        <div className=' absolute right-0 top-0'>
                            <IoClose 
                                onClick={() => setImageModal(false)} 
                                size={35} 
                                className=' text-primary-color cursor-pointer'
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    </>
  )
}

export default Image